import { useTranslation } from "react-i18next";
import BenefitCard from "./BenefitCard";
import {
  ShieldCheck,
  CreditCard,
  Zap,
  Clock,
  Percent,
  LineChart,
} from "lucide-react";

const benefitIcons = [Percent, LineChart, CreditCard, ShieldCheck, Zap, Clock];

const BenefitsSection = () => {
  const { t } = useTranslation();

  return (
    <section id="benefits" className="pt-20">
      <div className="">
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
            {t("migrationPage.benefits.title")}
          </h2>
          <p className="max-w-xl text-gray-600 dark:text-white/70">
            {t("migrationPage.benefits.intro")}
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mx-auto">
          {Array.from({ length: 6 }, (_, i) => i + 1).map((num) => (
            <BenefitCard
              key={num}
              icon={benefitIcons[num - 1]}
              title={t(`migrationPage.benefits.benefit${num}.name`)}
              description={t(
                `migrationPage.benefits.benefit${num}.description`,
              )}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
